export const LIST_PARENT_SESSION_PROMPTS_TOOL = 'list_parent_session_prompts';
export const GET_PARENT_SESSION_TURN_TRANSCRIPT_TOOL = 'get_parent_session_turn_transcript';
